const evaluation_form_dangerRouter = [
  {
      path: "list-danger",
      name: "evaluation_form_danger",
      component: () => import("@/views/admin/evaluation_form_danger"),
      default: true,
      meta: {
          model: "evaluation_form_danger",
          // requiresAuth: true,
      },
  },
  {
      path: "list-danger/evaluation/:id",
      name: "EvaluationFormDanger",
      component: () => import("@/views/admin/evaluation_form_danger/evaluation"),
      default: true,
      meta: {
          model: "evaluation_form_danger",
          // requiresAuth: true,
      },
  },
  {
    path: "list-danger/history",
    name: "EvaluationFormDangerHistory",
    component: () => import("@/views/admin/evaluation_form_danger/history"),
    default: true,
    meta: {
        model: "history_evaluation",
        // requiresAuth: true,
    },
  }
]
export default evaluation_form_dangerRouter;